import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import "./byteacherchart.scss";
import LoadingPage from "../../Include/LoadingPage";
import ReactApexChart from "react-apexcharts";

import { useQuery } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";
import { GET_STUDENT_ENROLLMENT_SHOW_BY_CLASSES } from "../../../Schema/Dashboard";

export default function TotalEnrollmentByTeacher({ academicYearId, schoolId, teacherId, teacherName }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_STUDENT_ENROLLMENT_SHOW_BY_CLASSES, {
    variables: {
      schoolId: schoolId ?? null,
      teacherId: teacherId ?? null,
      academicYearId: academicYearId ?? null,
    },
    onCompleted: ({ getStudentEnrollmentChartShowByClasses }) => {
      setTotalData(getStudentEnrollmentChartShowByClasses);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });


  const totalFemale = totalData?.map((e) => e?.female);
  const totalStudent = totalData?.map((e) => e?.totalStudent);
  // const maxSeriesData = Math.max(...(totalStudent?.length ? totalStudent : []));
  const classData = totalData?.map((e) => { return e?.levelName + " " + e?.groupName; });


  useEffect(() => {
    refetch();
  }, [academicYearId, schoolId, teacherId]);


  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false, 
        toolbar: { 
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val;
          } else {
            return "0";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: classData,
      },
      yaxis: {
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " នាក់";
            } else {
              return 0 + " នាក់";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("total_student"),
        data: totalStudent,
        color: "#0071F1",
      },
      {
        name: t("total_female"),
        data: totalFemale,
        color: "#01B6CB",
      },
    ],
  };

  return (
    <Box className="total-enrollment-by-teacher-chart">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("total_enrollment_by_teacher")} {teacherName}
        </Typography>
      </Stack>
      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={350}
            />
          </div>
      }
    </Box>
  );
}
